import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, NavLink, useParams } from "react-router-dom";
import API from "../../services";
import "./SeeAll.scss"
import { toast } from "react-toastify";
import { Autocomplete, TextField } from "@mui/material";
import { Error, FavoriteBorderOutlined, FavoriteOutlined, Search } from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import { shouldShowWagerNotice } from "../../constants/common";
import WagerNoticeDialog from "../WagerNoticeDialog/WagerNoticeDialog";

interface CasinoPageProps {
    activeWallet: any;  
}

const SeeAll: React.FC<CasinoPageProps> = ({
    activeWallet
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [gameData, setGameData] = useState<any>();
    const [searchQuery, setSearchQuery] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [pendingGameLink, setPendingGameLink] = useState("");
    const [showWagerNotice, setShowWagerNotice] = useState(false);
    const [pendingWagerGameLink, setPendingWagerGameLink] = useState("");

    let filteredGames = gameData?.filter((game: any) =>
        game?.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const { tag, title } = location.state || {};




    const getProviderInfo = async () => {
        setLoading(true);

        let response;
        try {
            response = await API.post(`/webapp/get-games-by-tag`, {
                tag: tag
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            toast.error(response.data?.errorDescription);
            navigate("/home");
        }

        if (response && response.data?.gamesList) {
            setGameData(response.data?.gamesList);
        }
        setLoading(false);
    };

    const handleGameClick = (game: any) => {

    }

    const handleFavoriteClick = async (game: any) => {

        setGameData((prevGameData: any) =>
            prevGameData.map((gameMap: any) =>
                gameMap?.id === game?.id
                    ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
                    : gameMap
            )
        );
        let response;
        try {
            // Make the API call to update the favorite status
            response = await API.post('/webapp/set-favorite', {
                category: game.category,
                id: game.id,
                isFavorite: !game.isFavorite,
                name: game?.name,
                provider: game?.provider,
                subProvider: game.subProvider,
                thumbnail: game.thumbnail,
                type: game.type,
                tgProviderId: game?.tgProviderId,
                tableId: game?.tableId,
                userKey: sessionStorage.getItem("userKey")
            });

        } catch (error) {
            console.error('Error updating favorite status:', error);
            // Revert the state change if the API call fails
        }

        if (response && response.data?.status === "RS_OK") {
            // getProviderInfo();
        }else{
            setGameData((prevGameData: any) =>
                prevGameData.map((gameMap: any) =>
                    gameMap?.id === game?.id
                        ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
                        : gameMap
                )
            );
        }
    };

    const handlePlayClick = (game: any) => {
        const encodedLink = `/play/${btoa(`${game?.id}::${game?.tgProviderId}:${game?.provider}:${game?.subProvider}:${game?.type}:${game?.category}:${game?.tableId ? game?.tableId : ""}:${game?.isLock}:${false}`)}`;

        if (activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled) {
            setPendingGameLink(encodedLink);
            setShowPopup(true);
        } else if (shouldShowWagerNotice(game?.is_wager)) {
            setPendingWagerGameLink(encodedLink);
            setShowWagerNotice(true);
        } else {
            navigate(encodedLink);
        }
    };



    useEffect(() => {
        getProviderInfo();
    }, []);

    return (
        <>
            <WagerNoticeDialog
                open={showWagerNotice}
                onCancel={() => {
                    setShowWagerNotice(false);
                    setPendingWagerGameLink("");
                }}
                onProceed={() => {
                    if (pendingWagerGameLink) navigate(pendingWagerGameLink);
                    setShowWagerNotice(false);
                    setPendingWagerGameLink("");
                }}
            />
            {
                loading ? (
                    <div className="home-loading">
                        <img src={Loader(domain)} style={{ height: '10rem' }} />
                    </div>
                ) : (
                    <>
                        {/* <div className="flex flex-col px-6 mt-4 w-full pb-[7rem] py-[4rem] provinfo"> */}
                        <div className="flex items-center justify-between px-6 mt-4 w-full pt-[4rem] pb-4 sticky top-0 z-10 seeall">
                            <div className="flex items-center">
                                <div>
                                    <div className="bg-inputbox-color flex p-1 mr-[1rem] rounded"
                                        onClick={() => navigate(-1)}
                                    >
                                        <ArrowBackIcon
                                            className="text-border-color aspect-square w-[18px]"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                <div className="capitalize text-sm">
                                    {title}
                                </div>
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search games..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="ml-4 p-2 border bg-inputbox-color border-border-color border rounded-md"
                                    style={{ width: "150px", height: '30px' }}
                                />
                            </div>
                        </div>
                        <div className="games-grid grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 pb-[7rem] px-4 provinfo">
                            {
                                filteredGames?.map((game: any, index: number) => (
                                    <>
                                        <div
                                            key={game.id + index}
                                            className="game-card cursor-pointer"
                                            onClick={() => handlePlayClick(game)}
                                        >
                                            <div className="game-tile relative overflow-hidden rounded-lg">
                                                <img
                                                    loading="lazy"
                                                    src={game.thumbnail}
                                                    style={{ objectFit: "unset" }}
                                                    alt={game.name}
                                                    onError={(e) => {
                                                        const t = e.target as HTMLImageElement;
                                                        t.onerror = null;
                                                        t.src = "https://cdn.stwin2025.co/TG/BotYaPot/Category/stikelogo1.svg";
                                                    }}
                                                    className={`w-full h-full rounded-lg object-cover relative mb-2 ${activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled ? "greyed-out" : ""
                                                        }`}
                                                />
                                                <div className="absolute top-[5px] right-[5px]">
                                                    {game?.isFavorite ? (
                                                        <FavoriteOutlined
                                                            className="gold-favourite-img"
                                                            titleAccess="remove from favourites"
                                                            onClick={(e) => { e.stopPropagation(); handleFavoriteClick(game); }}
                                                        />
                                                    ) : (
                                                        <FavoriteBorderOutlined
                                                            className="red-favourite-img"
                                                            style={{ fill: "white" }}
                                                            titleAccess="add to favourites"
                                                            onClick={(e) => { e.stopPropagation(); handleFavoriteClick(game); }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))
                            }
                        </div>
                        {/* </div> */}
                    </>
                )
            }
            {showPopup && (
                <Dialog
                    fullScreen={false}
                    open={showPopup}
                    onClose={() => {
                        setShowPopup(false);
                    }}
                    PaperProps={{
                        style: {
                            position: 'absolute',
                            top: '5rem'
                        }
                    }}
                >
                    <div className="dialog-bg bg-inputbox-color relative p-4">
                        {/* Close Button */}
                        <CloseIcon
                            className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
                            onClick={() => setShowPopup(false)}
                        />
                        <div className="text-white">
                            <h2 className="text-lg font-semibold mb-2">⚠️ Real Money Game Only</h2>
                            <p className="text-sm text-zinc-400 mb-4">
                                This game does not support play chips.
                                To play , you’ll need to use real money
                            </p>

                            <div className="flex justify-center">
                                <button
                                    type="button"
                                    className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                                    onClick={() => {
                                        setShowPopup(false);
                                        setPendingGameLink("");
                                    }}
                                >
                                    Close
                                </button>
                                {/* <button
                                    type="button"
                                    className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                                    onClick={() => {
                                        if (pendingGameLink) {
                                            navigate(pendingGameLink);
                                            setShowPopup(false);
                                        }
                                    }}
                                >
                                    Launch Game
                                </button> */}
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        activeWallet: state.userDetails?.activeWallet,
    };
};

export default connect(mapStateToProps)(SeeAll);

